/**
 * Feature Flag Enum
 *
 * Defines all available feature flags in the application.
 * Backend flags are synced from the API, frontend-only flags are checked from environment.
 */
export enum FeatureFlag {
  // Backend feature flags (synced from API)
  ENABLE_IBC_SUBMISSIONS = 'enable_ibc_submissions',
  APPEAL_SUBMISSIONS = 'appeal_submissions',
  UNIFIED_GRID = 'unified_grid',
  SYSTEM_OPERATIONS_API = 'system_operations_api',
  FEATURE_FLAG_MANAGEMENT = 'feature_flag_management_ui',
  USER_SITE_SERVICE_V2 = 'use_site_service_v2',
  MANUAL_COLLAB_HUB_NOTIFICATIONS = 'manual_collab_hub_notifications',
  NOTIFICATION_TEMPLATES = 'notification_templates',
  // Collab Hub 1.9 master flag (ERM-11601, iris-be #5836). One flag rules the whole
  // redesign on both sides: the backend gates its redesign behaviours on it, and the
  // drawer swaps in for the legacy side bar when it is on. Enabled per environment via
  // the backend's data.json seed (sbx-only until launch). Replaces the retired
  // per-story flags (collab_hub_notify_customer / unified_export / external_message_emails,
  // removed in iris-be #5772) and the build-time environment.collabHubDrawer env flag.
  COLLAB_HUB_REDESIGN = 'collab_hub_redesign',
  // Gates the AI-enabled (eRM <-> Jo) new study submission path (iris-be #5745/ERM-12200).
  AI_ENABLED_SUBMISSION = 'ai_enabled_submission',

  // Frontend-only feature flags (checked from environment)
  ENABLE_MOCK_IRIS = 'enableMockIris',
}
